import { render, staticRenderFns } from "./PaymentMethodItem.vue?vue&type=template&id=2ef970df&scoped=true&"
import script from "./PaymentMethodItem.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodItem.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentMethodItem.vue?vue&type=style&index=0&id=2ef970df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef970df",
  null
  
)

export default component.exports